import React from 'react';

import {
  borderedCircle,
  borderedCircleWrapper,
  borderPath,
  circleText,
} from '#Client/components/Circle/Circle.css';

export const Circle = ({fillPercent}: {fillPercent: number}) => (
  <span className={borderedCircleWrapper}>
    <svg className={borderedCircle} viewBox="0 0 36 36">
      <path
        className={borderPath}
        d="M18 2.0845
                a 15.9155 15.9155 0 0 1 0 31.831
                a 15.9155 15.9155 0 0 1 0 -31.831"
        strokeDasharray={`${fillPercent}, 100`}
      />
    </svg>
    <span className={circleText}>{fillPercent}%</span>
  </span>
);
